// regex expression used to check that a password has at least 1 special character
export const passwordRegex = /[@#$-/:-?{-~!^_`\[\]()*\\\\]/; // eslint-disable-line
// regex expression used to check the number of special characters in a password. This is used to calculate password strength
export const passwordStrengthRegex = /[@#$-/:-?{-~!^_`\[\]()*\\\\]/g; // eslint-disable-line
